/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/move'
export default icon
